// src/components/Faq.jsx
import React from 'react';
import styles from '../css/modules/Faq.module.css';

/**
 * FAQ na natywnych <details> - treść jest w HTML (widoczna dla robotów),
 * a użytkownik dostaje czytelną, zwiniętą listę zamiast ściany tekstu.
 * Pierwsza pozycja jest domyślnie rozwinięta.
 */
const Faq = ({ items = [] }) => (
  <div className={styles.faq}>
    {items.map((item, idx) => (
      <details key={item.question} className={styles.item} open={idx === 0}>
        <summary className={styles.question}>
          <h3>{item.question}</h3>
          <span className={styles.chevron} aria-hidden="true" />
        </summary>
        <div className={styles.answer}>
          <p>{item.answer}</p>
        </div>
      </details>
    ))}
  </div>
);

export default Faq;
